/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_3Inputs */



/**
* | output |
* | --- |
* | "Import over 30 different subtitle file formats" |
*
* @param {Signup_Feature_Starter_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_3 = /** @type {((inputs?: Signup_Feature_Starter_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
	if (locale === "it") return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
	if (locale === "es") return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
	return /** @type {LocalizedString} */ ("Import over 30 different subtitle file formats")
});